<template>
  <dynamic-input
    v-model="value"
    :options="filter"
    :no-label="noLabel"
    :class="version === 1 ? 'mr-4' : ''"
    :min-width="version === 1"
    :body-render="bodyRender"
  ></dynamic-input>
</template>

<script>
import { isFalsy } from "@/lib/helpers.js";
import { getQueryVariables, updateQueryParam } from "@/lib/url.js";

import DynamicInput from "@/components/DynamicInput.vue";

export default {
  components: {
    DynamicInput
  },
  props: {
    filter: {
      type: Object,
      default: () => ({})
    },
    noLabel: {
      // passed through
      type: Boolean,
      default: false
    },
    version: {
      type: Number,
      default: 1
    },
    bodyRender: {
      type: Boolean,
      default: true
    }
  },
  emits: ["refresh-table"],
  data() {
    return {
      value: this.filter.default_value
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.handleFilterChange(newValue);
      }
    }
  },
  created() {
    this.setInitialFilters();
  },
  methods: {
    clearValue() {
      this.value = "";
    },
    async handleFilterChange(value) {
      // Handle query param parsing on page to prevent duplicate requests
      // should only refresh table if the filter is removed or has changed values
      if (isFalsy(value) || !this.isFilterApplied(value)) {
        await updateQueryParam(this.filter.name, value, true);
        this.$emit("refresh-table");
      }
    },
    isFilterApplied(value) {
      // Check if filter is already applied
      const params = getQueryVariables();
      return params[this.filter.name] == value;
    },
    async setInitialFilters() {
      let params = getQueryVariables();
      // Set default filter value from backend
      if (
        !isFalsy(this.filter.default_value) &&
        isFalsy(params[this.filter.name])
      ) {
        if (this.version > 1) {
          // await updateQueryParam(
          //   this.filter.name,
          //   this.filter.default_value,
          //   true
          // );
        } else {
          // Is there a better way to handle defaults?
          // ATTENTION! This line is firing a second ajax request on every datatable init
          this.handleFilterChange(this.filter.default_value);
        }
      }
      // Update query params after setting default_value
      params = getQueryVariables();
      this.value = params[this.filter.name];
    }
  }
};
</script>

<style lang="scss" scoped></style>
